// infrontof_attribute
import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class InFrontOfAttribute extends AbstractBlock {
  constructor() {
    super('in_front_of_attribute', t.to('をリードする', 'in_front_of'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    const target = new Blockly.FieldTextInput('[camera]');
    const forward_z = new Blockly.FieldTextInput('3');
    const fix_y = new Blockly.FieldDropdown([
      [t.to('うごかす', 'fix_false'), 'false'],
      [t.to('うごかさない', 'fix_true'), 'true'],
    ]);

    block
      .appendDummyInput()
      .appendField(target, 'target')
      .appendField(t.to('をリードする', 'in_front_of'))
      .appendField(t.to('距離', 'offset'))
      .appendField(forward_z, 'forward_z')
      .appendField(t.to('Y方向を', 'fix_y'))
      .appendField(fix_y, 'fix_y');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const target = CodeSetting.getFieldValue(block, 'target');
    const forward_z = CodeSetting.getFieldValue(block, 'forward_z');
    const numForwordZ = parseInt(forward_z);
    const fix_y = CodeSetting.getFieldValue(block, 'fix_y');

    const str = CodeSetting.buildAttribute(
      [['in-front-of', `target:${target};forward:0 0 ${-1 * numForwordZ} 0;fix_y:${fix_y}`]],
      attribute
    );
    return [str];
  }
}
